import React from 'react';

const Vue_Routing = () => {
  return (
    <div>
      <h1>Vue_Routing Component</h1>
      <p>This is the Vue_Routing tutorial page.</p>
    </div>
  );
}

export default Vue_Routing;
